import { getSelectedLocation } from 'app/functions/location';

// todo: check for autocomplete
export const getArrivalLocation = arrivalCity => getSelectedLocation(arrivalCity);
